<template>
  <LoginConfig />
</template>

<script setup lang="ts">
import LoginConfig from './LoginConfig.vue';
</script>
